import AppBar from '@material-ui/core/AppBar'
import Grid from '@material-ui/core/Grid'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Spacing } from '@naturacosmeticos/natds-web'
import IconButton from '../../../components/Buttons/IconButton'
import Loading from '../../../components/Loading'
// eslint-disable-next-line import/no-cycle
import ErrorArea from '../../../components/Error/ErrorInfo'
// eslint-disable-next-line import/no-cycle
import { useNotification } from '../../../components/Notifications/Notifications'
import ScreenContainer from '../../../components/ScreenContainer/ScreenContainer'
import { snakeToCamel } from '../../../helpers/common'
import { getUserAuthFromLocalStorage } from '../../../helpers/auth'
import { useResponsiveness } from '../../../hooks/responsive'
import { useGetProspectDetailsSWR } from '../../../hooks/swrServices/useGetProspectDetailsSWR'
import { useTenantConfigs } from '../../../hooks/useTenantConfigs'
import { FunctionId, RoleId } from '../../../models/roles'
import { changeGroupPeopleService } from '../../../services/people'
import CancelRegistrationCard from './CancelRegistrationCard/CancelRegistrationCard'
import { EmailButton } from './EmailButton/EmailButton'
import AddressCard from './AddressCard'
import ChangeGroupCard from './ChangeGroupCard'
import CollaboratorRegistrationCard from './CollaboratorRegistrationCard'
import ConsultantRegistrationCard from './ConsultantRegistrationCard/ConsultantRegistrationCard'
import ContactCard from './ContactCard'
import DocumentsCard from './DocumentsCard/DocumentsCard'
import EditButton from './EditButton/EditButton'
import { ExpirationTokenDate } from './ExpirationTokenDate/ExpirationTokenDate'
import { MyBusinessButton } from './MyBusinessButton/MyBusinessButton'
import PersonalDataCard from './PersonalDataCard'
import SendLinkButton from './SendLink/SendLinkButton'
import BiometryResendButton from './BiometryResendButton'
import BiometryResendForm from './BiometryResendButton/BiometryResendForm'
import { useStyles } from './prospect-details.styles'
import Reprocess from './reprocess'

export default () => {
  const [isLoadingGroup, setIsLoadingGroup] = useState(false)
  const [showBiometryForm, setShowBiometryForm] = useState(false)
  const { id, status } = useParams()
  const {
 userData, isLoading: loading, hasError, reload,
} = useGetProspectDetailsSWR(id)
  const { isMobile, isDesktop } = useResponsiveness()
  const history = useHistory()
  const subStatus = userData?.substatus
  const classes = useStyles()
  const { notify } = useNotification()
  const { configs } = useTenantConfigs()
  const { user: { data } } = useSelector(({ user }) => user)

  const isBrazil = configs?.country?.alpha2Code === 'BR'
  const isPendingBiometrics = subStatus === 'PENDING_BIOMETRICS'
  const isGNOrLeader = data?.roles?.some((role) => role.endDate === null && (
      (role.functionId === configs?.roles?.gn?.functionId && role.roleId === configs?.roles?.gn?.roleId)
      || (role.functionId === configs?.roles?.leader?.functionId && role.roleId === configs?.roles?.leader?.roleId)
    ))
  const shouldShowBiometryButton = isPendingBiometrics && isBrazil && isGNOrLeader

  const showEditButton = userData?.isEditable && configs?.showEditButtonDetails && !shouldShowBiometryButton
  const EditButtonLinkedToProspectForm = () => (showEditButton ? <EditButton personId={id} display="block" /> : null)
  const showMyBusinessButton = configs?.showMyBusinessButton && isDesktop
  const MyBusinessButtonToProspectForm = () => (showMyBusinessButton ? <MyBusinessButton consultantCode={userData?.code} variant={showEditButton ? 'outlined' : 'contained'} /> : null)
  const ButtonEmail = () => (isDesktop ? <EmailButton email={userData?.email} /> : null)
  const shouldBreakLine = showEditButton || showMyBusinessButton

  const handleChangeGroup = async (newGroup) => {
    try {
      setIsLoadingGroup(true)
      const matchedRole = userData?.roles?.find((role) => (
        Number(role.roleId) === Number(configs?.roles?.cb?.roleId)
        && Number(role.functionId) === Number(configs?.roles?.cb?.functionId)
        && !role.endDate
      ))
      const functionId = matchedRole?.functionId || configs?.roles?.cb?.functionId || FunctionId.CB

      const originStructureCode = userData.structureCodeLevels.find((level) => level.value === userData.commercialStructure).value
      const originStructureLevelId = userData.structureCodeLevels.find((level) => level.value === userData.commercialStructure).level

      const storedAuth = getUserAuthFromLocalStorage()
      const resolvedUserId = Number(data?.code || storedAuth?.loginId || data?.id || data?.userid)
      const userId = !Number.isNaN(resolvedUserId) && resolvedUserId > 0 ? resolvedUserId : undefined
      const userName = data?.name || data?.username || ''

      const payload = {
        destinationStructureCode: newGroup?.code,
        destinationStructureLevelId: newGroup?.levelId,
        functionId,
        role: RoleId.CB,
        originStructureCode,
        originStructureLevelId,
        personCode: userData?.code,
        personId: id,
        headers: {
          businessmodelid: 1,
          countryid: configs.country?.alpha2Code,
          companyid: configs.company.id,
          'user-id': userId,
          'user-name': userName,
        },
      }

      await changeGroupPeopleService(payload)
      notify(<FormattedMessage id="changeGroupFeedback" defaultMessage="Group changed successfully" />)
    } catch (error) {
      notify(<FormattedMessage id="changeGroupFeedbackError" defaultMessage="Error changing group" />)
      console.error(error)
    } finally {
      await reload()
      setIsLoadingGroup(false)
    }
  }

  return (
    <ScreenContainer
      hasDrawer
      headerButtons={(
        <>
          {shouldBreakLine && <div className={classes.breakLine} />}
          <ButtonEmail />
          <Reprocess subStatus={subStatus} />
          <MyBusinessButtonToProspectForm />
          <EditButtonLinkedToProspectForm />
          <BiometryResendButton
            subStatus={subStatus}
            classNameBtn={classes.propectButton}
            onShowForm={() => setShowBiometryForm(true)}
          />
        </>
      )}
      title={
        isMobile ? (
          userData?.name
        ) : (
          <FormattedMessage id={snakeToCamel(status)} />
        )
      }
    >
      {hasError && <ErrorArea />}

      {!hasError && (loading || isLoadingGroup) && <Loading />}

      {!hasError && !loading && !isLoadingGroup && showBiometryForm && (
        <BiometryResendForm
          onBack={() => setShowBiometryForm(false)}
          prospectData={userData}
        />
      )}

      {!hasError && !loading && !isLoadingGroup && !showBiometryForm && (
        <>
          <ExpirationTokenDate />

          {isDesktop && (
            <AppBar
              elevation={1}
              data-testid="prospectNameAppBar"
              color="inherit"
              classes={{ root: classes.appBar }}
              position="static"
            >
              <Toolbar variant="dense" className={classes.prospectToolbar}>
                <div className={classes.headerStart}>
                  <IconButton edge="start" aria-label="back" onClick={() => history.goBack()}>
                    <ArrowBackIcon />
                  </IconButton>
                  <Typography className={classes.prospectName} variant="h6" color="inherit">
                    {userData?.name}
                  </Typography>
                </div>

                <Spacing display="flex">
                  <ButtonEmail />
                  <Reprocess subStatus={subStatus} />
                  <MyBusinessButtonToProspectForm />
                  <EditButtonLinkedToProspectForm />
                  {configs?.profile?.shouldDisplaySendLinkButton && (
                    <SendLinkButton subStatus={subStatus} classNameBtn={classes.propectButton} />
                  )}
                  {shouldShowBiometryButton && (
                    <BiometryResendButton
                      subStatus={subStatus}
                      classNameBtn={classes.propectButton}
                      onShowForm={() => setShowBiometryForm(true)}
                    />
                  )}
                </Spacing>
              </Toolbar>
            </AppBar>
          )}
          <Grid container spacing={1} classes={{ root: classes.gridContainer }}>
            <PersonalDataCard userData={userData} />
            <ContactCard userData={userData} personId={id} />
            <DocumentsCard userData={userData} cardTitleId="documents" cardTitleDefaultMessage="Documents" />
            <AddressCard
              cardTitleId="mailingAddress"
              cardTitleDefaultMessage="Mailing Address"
              personId={userData.personId}
              addressData={userData.addresses ? userData.addresses.MAILING : null}
            />
            <CollaboratorRegistrationCard userData={userData} />
            <ConsultantRegistrationCard userData={userData} />
            <ChangeGroupCard userData={userData} onChangeGroup={handleChangeGroup} />
            <CancelRegistrationCard userData={userData} />
          </Grid>
        </>
      )}
    </ScreenContainer>
  )
}
